import loader from "@/public/loader.gif";
import chrome from "@/public/gif/Both.gif";
import chromemobile from "@/public/gif/Chrome-mobile.gif";
import firefox from "@/public/gif/firefox.gif";
import otherApps from "@/public/gif/Others App Permission.gif";
import othermobile from "@/public/gif/other mobile.gif";
import firefoxmobile from "@/public/gif/Firefox mobile.gif";
import genericPermissions from "@/public/gif/Permission guide.gif";
import edgemobile from "@/public/gif/Edge mobile.gif";
import safari from "@/public/gif/Safari App Permission.gif";
import safarimobile from "@/public/gif/safari mobile.gif";
import edge from "@/public/gif/edge.gif";
import offerLoader from "@/public/offer-loader.gif";
import chromeiosmobile from "@/public/gif/chromeiosmobile.gif";
import samsungbrowser from "@/public/gif/samsungbrowser.gif";
import pillerCoinRotating from "@/public/gif/PillerCoinRotating.gif";
import toggle from "@/public/gif/toggle.gif";
export const GIFS = {
  loader,
  offerLoader,
  pillerCoinRotating,
  toggle,
  permissions: {
    chrome,
    chromemobile,
    firefoxmobile,
    firefox,
    edgemobile,
    edge,
    safari,
    otherApps,
    safarimobile,
    chromeiosmobile,
    samsungbrowser,
    othermobile,
    genericPermissions,
  },
};
